module.exports = __webpack_public_path__ + "4fe0d840e785757f9f175994eeb62110.pdf";